import {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import { Redirect, useHistory } from "react-router";
import { Grid, makeStyles, useMediaQuery, useTheme, Tooltip } from '@material-ui/core';
import { Helmet } from "react-helmet";
//import OverviewHeader from "./header";
import html2canvas from 'html2canvas';
//import OverviewLeftMenu from "./leftmenu";
//import Overall from "./sections/overall";
//import Audience from "./sections/audience";
import AudienceOverall from "./sections/audienceOverall";
import AudienceHigh from "./sections/audienceHigh";
import AudienceLow from "./sections/audienceLow";
import Agenda from "./sections/agenda";
//import HighLights from "./sections/highlights";
import BestMoments from "./sections/bestmoments";
import WorstMoments from "./sections/worstmoments";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSessionMarker,
  getAgendaImmersions,
  getAgendaSafes,
  getOverview,
  getSessionParticipants
} from "../../../../../store/actions/creator/creatorExperienceManager";
import { BackDropAnalyzeLoading } from '../../../../atoms/commonLoadings';
import _ from 'underscore';
import { updateUserMetricsValue } from '../../../../../store/actions/auth/auth'
import { getIdentifiers, } from '../../../../../store/actions/creator/analysis';
//import OverallPerformance from './sections/performance';
import OverallPerformanceMaster from './sections/performance/master';
import OverallPerformanceCompare from './sections/performance/compare';
import OverallPerformanceActions from './sections/performance/actions';
import OverallPerformanceStats from './sections/performance/stats';


//import OverviewBanner from "./banner";
import CustomSnackBar from "../participantsDashboard/component/CustomSnackBar";
import {onAddRemoveBenchmarkExperience} from "../../../../../store/actions/experience/experience";

import { Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '@material-ui/icons/Image';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import StarBorderIcon from '@material-ui/icons/StarBorder';
//import StarIcon from '@material-ui/icons/Star';
//import ShareIcon from '@material-ui/icons/Share';
//import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import OverviewCardHeader from './overviewCardHeader';
import Config from "../../../../../config/config";


import Joyride, { EVENTS, STATUS } from 'react-joyride';

const useStyles = makeStyles(() => ({
  root: {
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    background: '#F0F0F0',
    paddingTop: 37,
  },
  loadingDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  paddingHorizontal: {
    padding: '0 20px',
  },
  pdfMargin: {
    marginTop: (props: any) => props ? 50 : 10,
  },
  foo: {},
  setheight: {
    height: '100%',
  },
  cardHeaderKnown: {
    background: '#6667ab', 
    color: '#f2f2fa'
  },
  cardHeaderImmersion: {
    background: '#017AEF', 
    color: '#ffffff'
  },
  cardHeaderLively: {
    background: '#19191e', 
    color: '#f2f2fa'
  },
  cardHeaderWondr: {
    background: '#FDCA42', 
    color: '#19191e'
  },
  cardContentKnown: {
    background: '#f2f2fa', 
  },
  cardIconKnown: {
    color: '#f2f2fa', 
  },
  cardIconLively: {
    color: '#ffffff', 
  },
  cardIconWondr: {
    color: '#19191e', 
  },
  cardIconImmersion: {
    color: '#ffffff', 
  },
  cardContentImmersion: {
    background: '#ffffff', 
  },
  maingrid: {
        marginTop: '50px',
        width: '90%',
  },
  marginbottom30: {
    marginBottom: '30px',
  },
  mainSection: {
    padding: '0 40px 150px 0',
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
    position: 'relative',
    margin: "20px",
    '@media (min-width: 2000px)': {
      width: 1200
    },
    '@media (max-width: 1150px)': {
      padding: '0 0 150px 0',
    },
    '@media (max-width: 600px)': {
      padding: '0',
      marginTop: 40
    },
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  tour_step_one: {},
  tourTitle: {
    textAlign: 'right', 
    paddingTop: '20px', 
    fontFamily: 'Spartan-extrabold', 
    fontSize: '1.7em'
  },
  tourListItem: {
    textAlign: 'left', 
    paddingTop: '10px', 
    fontFamily: 'roboto-regular',
    fontSize: '1em'
  }
}));

export default function Overview(props: any) {

  const { initialClipLoaded, stimulus, settings, cliped, fullLoadedAnalysis, attendedIdentifiers, excludedParticipants } = useSelector((state: any) => state.analysis);
  const { pdfLoading, clipLoading, videoRemoved } = settings;

  const classes = useStyles(pdfLoading);
  const dispatch = useDispatch();
  const history = useHistory();
  const scrollRef: any = useRef();

  const queryStringOverview = new URLSearchParams(props.history.location.search).get("overview")
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const {
    sessionData,
    audienceImmersions,
    audienceSafes,
    highlights,
    immersionIndex,
    safetyIndex,
    agendaImmersions,
    agendaSafes,
    identifiers,
    overviewAgendas,
    overviewMarkers,
    fullLoaded,
    highestSegments,
    lowestSegments,
    // overviewLoadingTime
  } = useSelector((state: any) => state.creatorExperienceManager);

  const participants = useSelector((state: any) => state.experience.participants);

  const [sessionCode, setSessionCode] = useState(props.match.params.session_code);
  const [prevMarkers, setPrevMarkers] = useState([{ start: 0, end: 0, marker_title: '' }]);
  const [updateUserMetrics, setUpdateUserMetrics] = useState(false);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));
  const session_type = sessionData && sessionData['session']['session_type'];

  const attendLoading = (session_type === 'ASYNC' ? identifiers.length : attendedIdentifiers.length) > 0 ? !fullLoadedAnalysis : false;
  const fullLoading = pdfLoading || !sessionData || !fullLoaded || clipLoading || attendLoading;
  const [alertType, setAlertType] = useState('success');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  const [benchmarkLoading, setBenchmarkLoading] = useState(false);
  //const [showBanner, setShowBanner] = useState(true);
  const [isBenchmark, setIsBenchmark] = useState(false);
  const [confidenceScore, setConfidenceScore] = useState('');

  const overviewRef = useRef();
  const bestMomentsRef = useRef();
  const worstMomentsRef = useRef();
  const audienceRef = useRef();
  const audienceHighRef = useRef();
  const audienceLowRef = useRef();
  const agendaRef = useRef();

  //const [sawKnownOnboardingTour, setSawKnownOnboardingTour] = useState(false);
  const [runKnownOnboarding, setKnownRunOnboarding] = useState(true);
  const [runLivelyOnboarding, setLivelyRunOnboarding] = useState(true);

const forceOnboardingtoFalse = false;


  useEffect(() => {
    const sawkOb = localStorage.getItem('sawKnownOnboardingTour') === 'true' ? true : false;
    console.log(`saw onboard = ${sawkOb}`);
    const sawlOb = localStorage.getItem('sawLivelyOnboardingTour') === 'true' ? true : false;

    if (sawkOb) {
      setKnownRunOnboarding(false);
    }

    if (sawlOb) {
      setLivelyRunOnboarding(false);
    }
  }, []);

  console.log(`runLivelyOnboarding = ${runLivelyOnboarding}`);

  const handleJoyrideCallback = (data: any) => {
    const { status, type } = data;

    console.log(data); 

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      //this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    }
    else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      //this.setState({ run: false });
      if (sessionData && sessionData['session']['session_type'] === 'ASYNC') {
        setKnownRunOnboarding(false);
        localStorage.setItem('sawKnownOnboardingTour', JSON.stringify(true));
      } else {
        setLivelyRunOnboarding(false);
        localStorage.setItem('sawLivelyOnboardingTour', JSON.stringify(true));
      }
    }

    //console.groupCollapsed(type);
    //eslint-disable-line no-console
    //console.groupEnd();
  };

  const handleDownloadImage = async (element: any, name: string) => {
    //const element: any = overviewRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL('image/jpg');
    const link = document.createElement('a');

    if (typeof link.download === 'string') {
      link.href = data;
      link.download = name + '_image.jpg';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  const livelyTourSteps = [
    {
      target: 'body',
      placement: 'center' as const,
      content: 
      <Grid container direction={'row'} spacing={3} >
        <Grid item xs={6}>
          <img src={'/assets/images/paul_welcome.png'} style={{width: '300px'}} />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h5" className={classes.tourTitle}>Immersion is the measure of what your brain values.</Typography>
            <Typography variant="h5" className={classes.tourTitle}>It predicts audience action & memory with remarkable accuracy</Typography>
            <ul  className={classes.tourListItem}>
              <li>100 is good, 0 is bad</li>
              <li>Green is good, red is bad</li>
              <li>Check out the shape of your experience</li>
              <li>The higher the immersion, the more likely an audience will take action</li>
            </ul>
          </Grid>
      </Grid>
      ,
      disableBeacon: true,
      showSkipButton: false,
      hideCloseButton: true,
      styles: {
        options: {
          width: 700,
        }
      }
    },
    {
      target: '#litscore',
      title: 'Lively Score',
      placement: "left" as const,
      content: 'This is the most important part. It tells you everything you need to know about the experience. Score, safety, and shape.',
      disableBeacon: true,
    },
    {
      target: '#litcommentary',
      title: 'Lively Commentary',
      placement: "right" as const,
      content: "By looking at all the factors in this experience, our platform will provide some commentary and recommendations on next steps.",
      disableBeacon: true,
    },
    {
      target: '#statsbox',
      title: 'Get into the details...',
      placement: 'top' as const,
      content: "This section will give you all the details on each measurement result and some links to actions you should take.",
      disableBeacon: true,
    },
    {
      target: '#benchmarkbox',
      title: 'How does this compare?',
      placement: 'top-start' as const,
      content: "You want to know how this experience compared to everything like it that we have ever measured, and how does it compare to the best things you have measured.  Well, here ya go!",
      disableBeacon: true,
    },
    {
      target: '#agenda_section',
      title: 'Did you load an Agenda?',
      placement: 'top-start' as const,
      content: "When you load an agenda to the experience, our platform will break things down to give you scores by section.",
      disableBeacon: true,
    },
    {
      target: '#audience_card',
      title: 'Your Audience',
      placement: 'top' as const,
      content: "Now you can see the details on the audience.  How many were 'Captivated' and how many were 'tuned out' during the experience.",
      disableBeacon: true,
    },
  ];

  const knownTourSteps = [
    {
      target: 'body',
      placement: 'center' as const,
      content: 
      <Grid container direction={'row'} spacing={3} >
        <Grid item xs={6}>
          <img src={'/assets/images/paul_welcome.png'} style={{width: '300px'}} />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h5" className={classes.tourTitle}>Immersion is the measure of what your brain values.</Typography>
            <Typography variant="h5" className={classes.tourTitle}>It predicts audience action & memory with remarkable accuracy</Typography>
            <ul  className={classes.tourListItem}>
              <li>100 is good, 0 is bad</li>
              <li>Green is good, red is bad</li>
              <li>The higher the immersion, the more likely an audience will take action</li>
            </ul>
          </Grid>
      </Grid>
      ,
      disableBeacon: true,
      showSkipButton: false,
      hideCloseButton: true,
      styles: {
        options: {
          width: 700,
        }
      }
    },
      {
        target: '#holder',
        title: 'Overview',
        placement: 'left' as const, 
        content: 'Get a quick overview of your results.',
        disableBeacon: true,
      },
      {
        target: '#immbox',
        title: 'Immersion Score',
        placement: 'bottom' as const,
        content: 'This is the overall Immersion for the experience. It\'s the combination of attention and emotional resonance. The higher the number the more likely it is to create action in your audience.',
        disableBeacon: true,
      },
      {
        target: '#conbox',
        title: 'Confidence Score',
        placement: 'bottom' as const,
        content: 'This will tell you how confident you should be in the results. Just like a letter grade in school, you should try to get an \'A\'.',
        disableBeacon: true,
      },
      {
        target: '#overviewpills',
        title: 'Graph, Pills, & Dots',
        placement: 'top' as const,
        content: "The graph is showing you second-by-second how brains responded to the content. The colored pills show you sections that averaged high or low scores, and the dots are moments that are significant (pay attention to these!)",
        disableBeacon: true,
      },
      {
        target: '#toolsgroup',
        title: 'Your Tool Bar',
        placement: 'left' as const,
        content: "These toolbar buttons allow you to see your clips, share, and export sections.",
        disableBeacon: true,
        styles: {
          options: {
            zIndex: 1000,
          }
        }
      },
      {
        target: '#actionsbox',
        title: 'What should you do next?',
        placement: 'top-start' as const,
        content: "Our platform will offer you a few ideas and suggestions on next steps you should take based on these results.",
        disableBeacon: true,
      },
      {
        target: '#statsbox',
        title: 'Get into the details...',
        placement: 'top' as const,
        content: "This section will give you all the details on each measurement result and some links to actions you should take.",
        disableBeacon: true,
      },
      {
        target: '#benchmarkbox',
        title: 'How does this compare?',
        placement: 'top-start' as const,
        content: "You want to know how this experience compared to everything like it that we have ever measured, and how does it compare to the best things you have measured.  Well, here ya go!",
        disableBeacon: true,
      },
      {
        target: '#best_moments_section',
        title: 'Your Best Moments',
        placement: 'top' as const,
        content: "This section will show you the very best moments in the experience.",
        disableBeacon: true,
      },
      {
        target: '#worst_moments_section',
        title: 'Your Bummer Moments',
        placement: 'top' as const,
        content: "This section will show you the moments in the experience that need some work.",
        disableBeacon: true,
      },
      {
        target: '#audience_card',
        title: 'Your Audience',
        placement: 'top' as const,
        content: "Now you can see the details on the audience.  How many were 'Captivated' and how many were 'tuned out' during the experience.",
        disableBeacon: true,
      },
    ];
  

//console.log(knownTourSteps);


  useEffect(() => {
    if (!!participants && participants.participant_status && participants?.participants.length >= 1 ) {
      const score = getConfidenceScore(participants?.participant_status, participants?.participants);
      console.log(`CONFIDENCE SCORE ON OVERVIEW IS: ${score}`);
    }
  }, [participants]);

  const getConfidenceScore = (pStatus: any, parts: any) => {
    const SENSOR_MAGIC_NUMBER = 40;
    const PULSE_MAGIC_NUMBER = 150;
  
    const totalCompleted = pStatus?.completed;
    let calculatedScore = "D";
  
    const fpCount2 = parts.filter(function(item: any) {
      return item.participant_status === "COMPLETED" && item.user_devices?.sensor_type === "PUL"
    }).length;
  
    if (fpCount2 === 0) {
        // no fp people in this exp, so...
        console.log("getSimpleGrade");
        calculatedScore = getSimpleGrade(totalCompleted);
    } else if (fpCount2 === totalCompleted) {
        //all FP people
        console.log("getSimplePulseGrade");
        calculatedScore = getSimplePulseGrade(totalCompleted);
    } else {
      //fancy scoring....
      const sensorCount = totalCompleted - fpCount2;
      const score = (fpCount2/PULSE_MAGIC_NUMBER) + (sensorCount/SENSOR_MAGIC_NUMBER);
      console.log(`getScoredGrade -- ${sensorCount} and ${score}`);
      calculatedScore = getScoredGrade(score);
  
    }
    //console.log(`part breakdown is ${totalCompleted} and ${fpCount2} pulse people`);
    setConfidenceScore(calculatedScore);
    return calculatedScore;
  }
      
  const getScoredGrade= (score: any) => {
    if (score >= 1.3 ) {
      return "A+";
    } else if (score >= 1.0 && score < 1.3) {
      return "A";
    } else if (score >= 0.75 && score < 1.0) {
      return "B+";
    } else if (score >= 0.5 && score < 0.75) {
      return "B";
    } else if (score >= 0.1 && score < 0.5) {
      return "C";
    } else {
      return "D";
    }
  }
  
  const getSimpleGrade= (count: any) => {
    if (count >= 40 ) {
      return "A+";
    } else if (count >= 35 && count < 40) {
      return "A";
    } else if (count >= 25 && count < 35) {
      return "B+";
    } else if (count >= 15 && count < 25) {
      return "B";
    } else if (count >= 1 && count < 15) {
      return "C";
    } else {
      return "D";
    }
  }
  
  const getSimplePulseGrade= (count: any) => {
    if (count >= 170 ) {
      return "A+";
    } else if (count >= 150 && count < 170) {
      return "A";
    } else if (count >= 125 && count < 150) {
      return "B+";
    } else if (count >= 100 && count < 125) {
      return "B";
    } else if (count >= 50 && count < 100) {
      return "C+";
    } else {
      return "C";
    }
  }



  useEffect(() => {
    history.push(window.location.pathname)
  }, [queryStringOverview]);

  useEffect(() => {
    const state = props.history.location.state;
    if (state) {
      if (state.session_id && state.session_id !== undefined) {
        localStorage.setItem('session_id', state.session_id);
      }
    }
  }, [props.history.location]);

  useEffect(() => {
    const session_code = props.match.params.session_code;
    setSessionCode(session_code);
    if (session_code)
      localStorage.setItem('session_code', session_code);
  }, [props.match.params.session_code]);

  useEffect(() => {
    if (sessionData && (sessionData['session']['session_status'] === 'COMPLETED' || (sessionData['session']['session_type'] === 'ASYNC')) && identifiers.length > 0 && overviewMarkers.length > 0) {
      const fetchAgendaData = async () => {
        const reqAgenda = {
          tenant_id: loginUserData.customer_id,
          session_code: sessionCode,
          session_started_at: getTime(sessionData['session']['started_at']),
          session_completed_at: getTime(sessionData['session']['ended_at']),
          from_epoch: getTime(sessionData['session']['started_at']),
          to_epoch: getTime(sessionData['session']['ended_at']),
          markers: overviewMarkers,
          identifiers: identifiers.filter((item: any) => !excludedParticipants.includes(item))
        };
        dispatch(await getAgendaImmersions(reqAgenda));
        dispatch(await getAgendaSafes(reqAgenda));
      };

      const fetchCommentData = async () => {
        dispatch(await fetchSessionMarker(apolloClient.client, { session_code: sessionCode }, null))
      };
      fetchAgendaData();
      fetchCommentData();
    }
  }, [sessionData, prevMarkers, identifiers, excludedParticipants]);

  useEffect(() => {
    if (!checkMarkersEqual()) {
      setPrevMarkers([...overviewMarkers]);
    }
  }, [overviewMarkers]);

  //Report card hangs with loader and never loads until a refresh.
  // useEffect(() => {
  //   if(overviewLoadingTime > 20 && overviewLoadingTime < 60){
  //     window.location.reload();
  //   }
  // }, [overviewLoadingTime])

  const checkMarkersEqual = () => {
    if (!prevMarkers || !overviewMarkers) return false;
    return _.isEqual(prevMarkers, overviewMarkers)
  };

  useEffect(() => {
    const request = { session_code: sessionCode };
    dispatch(fetchSessionMarker(apolloClient.client, request, null));
    const overviewReq = cliped ? { 
      clip_id: cliped.clip_id, 
      session_code: sessionCode,
      from_clip: cliped.start,
      to_clip: cliped.end
    } : { session_code: sessionCode };
    dispatch(getOverview(apolloClient.client, overviewReq));
  }, [cliped]);


  useEffect(() => {
    if (participants && participants.session) {
      const session = participants.session;
      console.log(session.saved_benchmark);
      setIsBenchmark(session.saved_benchmark);
    }
  }, [participants]);

  


  useEffect(() => {
    if (sessionData && sessionData['session']['session_type'] === 'ASYNC' && sessionData['session']['session_status'] === 'LIVE') {
      const myIntervalOverall = setInterval(() => { // every 5 minutes update
        dispatch(getIdentifiers(apolloClient.client, sessionCode));
        const overviewReq = cliped ? { clip_id: cliped.clip_id, session_code: sessionCode } : { session_code: sessionCode };
        dispatch(getOverview(apolloClient.client, overviewReq));
        dispatch(getSessionParticipants(apolloClient.client, { session_code: sessionCode }));
      }, 300000);
      return () => {
        clearInterval(myIntervalOverall);
      };
    }
  });

  const thumbnailImg = useMemo(() => {

    const stimulus_url = stimulus && stimulus.thumbnails && stimulus.thumbnails[0]?.url;

    if (videoRemoved) {
      return participants?.session?.large_thumbnail
    }

    if (stimulus_url && stimulus_url !== '' && !videoRemoved) {
      return stimulus_url;
    }

    return participants?.session?.large_thumbnail ? participants?.session?.large_thumbnail : '';
  }, [participants, stimulus, videoRemoved]);

  if (!sessionCode) {
    return <Redirect to='/creator/dashboard' />
  }

  const getTime = (time: string) => {
    if (!time) return 0;
    if (time.length > 10) {
      return Number(time.slice(0, 10))
    } else {
      return Number(time);
    }
  };

  useEffect(() => {
    if (sessionData && sessionData.session && sessionData.session.session_status && (sessionData.session.session_status === 'COMPLETED' || sessionData.session.session_status === 'LIVE') && !sessionData.session.braintrust_id && !sessionData.session.quicktest && (immersionIndex?.immersion_index > 1)) {
      if (!updateUserMetrics) {
        setUpdateUserMetrics(true)
      }
    }
  }, [sessionData, immersionIndex]);

  useEffect(() => {
    if (updateUserMetrics) {
      dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "EXPERIENCEOVERVIEW" }))
      dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "EXPERIENCESWITHDATA", metrics_value: sessionCode }))
    }
  }, [updateUserMetrics]);

  useEffect(() => {
    console.log(scrollRef);
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [pdfLoading]);


  const updateBenchmark = () => {
    if (participants && participants.session) {
      const session = participants.session;
      setBenchmarkLoading(true);

      const request = {
        session_id: session.session_id,
        department_id: Number(loginUserData.department_id),
        star: isBenchmark ? false : true,
        user_id: Number(loginUserData.user_id),
        sessions: [String(session.session_id)]
      };
      dispatch(onAddRemoveBenchmarkExperience(apolloClient.client, request, (res: any) => {
        if (res) {
          //setShowBanner(false);
          setBenchmarkLoading(false);
          setIsBenchmark(isBenchmark ? false : true);
          setAlertMsg(isBenchmark ? 'Experience successfully removed from your Benchmarks.' : 'Experience successfully saved to your Benchmarks.');
          setAlertType('success');
          setShowAlert(true);

        } else {
          setBenchmarkLoading(false);
          onBannerErrorAlert('Experience saving to your benchmarks is failed.');
        }
      }));


    }
  }


  
  const downloadOverviewSection = useCallback(() => {
    handleDownloadImage(overviewRef.current, 'overview');
  }, [participants, sessionCode]);

 

  const onBannerErrorAlert = (message: string) => {
    setAlertMsg(message);
    setAlertType('error');
    setShowAlert(true);
  };

  
  const getCardHeaderClass = () => {
    if (Config.DEFAULT_SUBBRAND == 'known') {
      return classes.cardHeaderKnown;
    } else if (Config.DEFAULT_SUBBRAND == 'lively') {
      return classes.cardHeaderLively;
    } else if (Config.DEFAULT_SUBBRAND == 'wondr') {
      return classes.cardHeaderWondr;
    } else {
      return classes.cardHeaderImmersion;
    }
  };

  const getCardContentClass = () => {
    if (Config.DEFAULT_SUBBRAND == 'known') {
      return classes.cardContentKnown;
    } else if (Config.DEFAULT_SUBBRAND == 'lively') {
      return classes.cardContentKnown;
    } else if (Config.DEFAULT_SUBBRAND == 'wondr') {
      return classes.cardContentKnown;
    } else {
      return classes.cardContentImmersion;
    }
  };

  const getCardIconClass = () => {
    if (Config.DEFAULT_SUBBRAND == 'known') {
      return classes.cardIconKnown;
    } else if (Config.DEFAULT_SUBBRAND == 'lively') {
      return classes.cardIconLively;
    } else if (Config.DEFAULT_SUBBRAND == 'wondr') {
      return classes.cardIconWondr;
    } else {
      return classes.cardIconImmersion;
    }
  };

  const getBrandColor = (t: string) => {
    if (Config.DEFAULT_SUBBRAND == 'known') {
      if (t === 'background') {
        return '#6667ab';
      } else if (t === 'color') {
        return '#f2f2fa';
      } else if (t === 'star') {
        return '#FDCA42';
      }

    } else if (Config.DEFAULT_SUBBRAND == 'lively') {
      if (t === 'background') {
        return '#19191e';
      } else if (t === 'color') {
        return '#f2f2fa';
      } else if (t === 'star') {
        return '#FDCA42';
      }

    } else if (Config.DEFAULT_SUBBRAND == 'wondr') {
      if (t === 'background') {
        return '#FDCA42';
      } else if (t === 'color') {
        return '#19191e';
      } else if (t === 'star') {
        return '#6667ab';
      }



    } else {
      if (t === 'background') {
        return '#017AEF';
      } else if (t === 'color') {
        return '#ffffff';
      } else if (t === 'star') {
        return '#FDCA42';
      }
    }
    return "#19191e";
  };
  


console.log(sessionData?.session);
//console.log(livelyTourSteps);

  return (
    <>
    <div
      className={classes.root}
      style={ pdfLoading ? { width: 1860 } : {}}
      ref={scrollRef}
    >

      
      <Helmet title="Overview">
        </Helmet>
      
      {/*<div style={{ display: 'flex', flexDirection: 'column'}}>*/}
        

        <BackDropAnalyzeLoading loading={fullLoading || benchmarkLoading} />

        <Grid container spacing={3} direction={'column'} alignContent={'center'} id="KnownResultsHolder" style={{paddingBottom: '50px'}}>
        <Grid container spacing={3} direction={'row'} alignContent={'center'} id="KnownResultsOverview" className={classes.maingrid}>

          {/**  result overview section */}
        <Grid item xs={12} sm={12} className={classes.tour_step_one}>
                

                <Card className={classes.foo} ref={overviewRef}>

                  <OverviewCardHeader 
                    sessionCode={sessionCode} 
                    session={participants?.session}
                    onSaveBenchmark={updateBenchmark} 
                    onDownloadImage={downloadOverviewSection}
                    backgroundColor={getBrandColor('background')} 
                    fontColor={getBrandColor('color')} 
                    isBenchmark={isBenchmark} 
                    starColor={getBrandColor('star')} 
                  />

                    <CardContent className={getCardContentClass()}>
                        
                    {sessionData && participants && confidenceScore && (
                    <OverallPerformanceMaster
                          participantsStatus={participants && participants.participant_status}
                          session={sessionData?.session}
                          immersionData={immersionIndex}
                          thumbnail={thumbnailImg}
                          safetyData={safetyIndex}
                          sessionCode={sessionCode}
                          isMobile={isMobileDevice}
                          confidenceScore={confidenceScore}
                        />
                    )}

                    {sessionData && participants && confidenceScore && (sessionData['session']['session_type'] === 'ASYNC') && (
                      <>

                        
                        <OverallPerformanceActions
                          participantsStatus={participants && participants.participant_status}
                          session={sessionData?.session}
                          immersionData={immersionIndex}
                          thumbnail={thumbnailImg}
                          safetyData={safetyIndex}
                          sessionCode={sessionCode}
                          isMobile={isMobileDevice}
                          confidenceScore={confidenceScore}
                        />    

                        




                      </>
                    )}

                        <OverallPerformanceStats
                          participantsStatus={participants && participants.participant_status}
                          participants={participants}
                          session={sessionData?.session}
                          immersionData={immersionIndex}
                          thumbnail={thumbnailImg}
                          audienceImmersions={audienceImmersions}
                          bestMoments={highlights ? highlights['best_moments'] : []}
                          worstMoments={highlights ? highlights['worst_moments'] : []}
                          safetyData={safetyIndex}
                          sessionCode={sessionCode}
                          isMobile={isMobileDevice}
                          confidenceScore={confidenceScore}
                        />    


                      <OverallPerformanceCompare
                        participantsStatus={participants && participants.participant_status}
                        session={sessionData?.session}
                        immersionData={immersionIndex}
                        safetyData={safetyIndex}
                        sessionCode={sessionCode}
                        isMobile={isMobileDevice}
                      />

                       

                     


                    </CardContent>
                </Card>
            </Grid>


            {/**  result overview best worst row 
             * only show for completed and pre-recorded content
            */}
            {sessionData && (sessionData['session']['session_status'].toLowerCase() === 'completed' &&
                sessionData['session']['session_type'] === 'ASYNC') && (
                 <>
            <Grid item xs={12} md={6}>
                <Card className={classes.setheight} ref={bestMomentsRef} id={'best_moments_section'}>
                    <CardHeader title="Best Moments" className={getCardHeaderClass()} action={
                      <Tooltip title="Save this section as an image">
                        <IconButton aria-label="settings">
                            <ImageIcon className={getCardIconClass()} onClick={() => handleDownloadImage(bestMomentsRef.current, 'best_moments') }/>
                        </IconButton>
                        </Tooltip>
                        }/>
                    <CardContent className={getCardContentClass()}>
                        <Typography variant="body2" color="textSecondary" component="p" className={classes.marginbottom30}>
                        These Best Moments are scientifically more likely to be remembered by your audience. They are a great place to ensure your most important content appears.
                        </Typography>


                        
                        {
                        highlights &&
                        initialClipLoaded &&
                        <BestMoments
                          isMobile={isMobileDevice}
                          session={sessionData['session']}
                          bestMoments={highlights['best_moments']}
                          worstMoments={highlights['worst_moments']}
                        />
                      }


                    </CardContent>
                </Card>
            </Grid>
                

            <Grid item xs={12} md={6} >
                <Card className={classes.setheight} ref={worstMomentsRef} id={'worst_moments_section'}>
                    <CardHeader title="Worst Moments"  className={getCardHeaderClass()} action={
                      <Tooltip title="Save this section as an image">
                        <IconButton aria-label="settings">
                            <ImageIcon  className={getCardIconClass()}  onClick={() => handleDownloadImage(worstMomentsRef.current, 'worst_moments') }/>
                        </IconButton>
                        </Tooltip>
                        }/>
                    <CardContent className={getCardContentClass()}>
                        <Typography variant="body2" color="textSecondary" component="p" className={classes.marginbottom30}>
                        These Worst Moments are scientifically more likely to be forgotten by your audience. You will want to minimize the number and length of these moments.
                        </Typography>


                        
                        {
                        highlights &&
                        initialClipLoaded &&
                        <WorstMoments
                          isMobile={isMobileDevice}
                          session={sessionData['session']}
                          bestMoments={highlights['best_moments']}
                          worstMoments={highlights['worst_moments']}
                        />
                      }


                    </CardContent>
                </Card>
            </Grid>
                    
            </>
           )}


          {/**  result AGENDA row 
             * only show for live content
            */}
          {sessionData && (sessionData['session']['session_type'] !== 'ASYNC') && (
                 <>
            <Grid item xs={12} md={12}>
                <Card className={classes.foo} ref={agendaRef} id={'agenda_section'}>
                    <CardHeader title="Agenda"  className={getCardHeaderClass()} action={
                      <Tooltip title="Save this section as an image">
                        <IconButton aria-label="settings">
                            <ImageIcon  className={getCardIconClass()} onClick={() => handleDownloadImage(agendaRef.current, 'agenda') } />
                        </IconButton>
                        </Tooltip>
                        }/>
                    <CardContent className={getCardContentClass()}>
                        
                        {
                        sessionData['session']['session_type'] !== 'ASYNC' &&
                        initialClipLoaded &&
                        <Agenda
                          overviewAgendas={overviewAgendas}
                          agendaImmersions={agendaImmersions}
                          agendaSafes={agendaSafes}
                          isMobile={isMobileDevice}
                        />
                      }
                    </CardContent>
                </Card>
            </Grid>

            </>
           )}

          
          {/**  result audience breakdown row 
             * only show for completed content
            */}
            {sessionData && (sessionData['session']['session_status'].toLowerCase() === 'completed') && (
                 <>
              <Grid item xs={12} md={12}>
                    <Card className={classes.foo} ref={audienceRef} id={'audience_card'}>
                        <CardHeader title="Audience Breakdown"  className={getCardHeaderClass()} action={
                          <Tooltip title="Save this section as an image">
                        <IconButton aria-label="settings">
                            <ImageIcon  className={getCardIconClass()} onClick={() => handleDownloadImage(audienceRef.current, 'audience_breakdown') } />
                        </IconButton>
                        </Tooltip>
                        }/>
                        <CardContent className={getCardContentClass()}>
                            <Typography variant="body2" color="textSecondary" component="p">
                            How Immersed were your participants during this experience?
                            </Typography>


                            <AudienceOverall
                              audienceImmersions={audienceImmersions}
                              audienceSafes={audienceSafes}
                              safetyData={safetyIndex}
                              isMobile={isMobileDevice}
                            />

                        </CardContent>
                    </Card>
                </Grid>
                

            <Grid item xs={12} md={6}>
                <Card className={classes.setheight} ref={audienceHighRef}>
                    <CardHeader title="Highest Immersion Groups"  className={getCardHeaderClass()} action={
                      <Tooltip title="Save this section as an image">
                        <IconButton aria-label="settings">
                            <ImageIcon  className={getCardIconClass()} onClick={() => handleDownloadImage(audienceHighRef.current, 'audience_high_breakdown') }/>
                        </IconButton>
                        </Tooltip>
                        }/>
                    <CardContent className={getCardContentClass()}>
                        <Typography variant="body2" color="textSecondary" component="p">
                        When you tag your participants, you will be able to see the highest Immersion groups.
                        </Typography>

                        
                        <AudienceHigh
                              highestSegments={highestSegments}
                              lowestSegments={lowestSegments}
                              participantsStatus={participants && participants.participant_status}
                            />

                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} md={6}>
                <Card className={classes.setheight} ref={audienceLowRef}>
                    <CardHeader title="Lowest Immersion Groups"  className={getCardHeaderClass()} action={
                      <Tooltip title="Save this section as an image">
                        <IconButton aria-label="settings">
                            <ImageIcon  className={getCardIconClass()} onClick={() => handleDownloadImage(audienceLowRef.current, 'audience_low_breakdown') }/>
                        </IconButton>
                        </Tooltip>
                        }/>
                    <CardContent className={getCardContentClass()}>
                        <Typography variant="body2" color="textSecondary" component="p">
                        When you tag your participants, you will be able to see the lowest Immersion groups.
                        </Typography>

                        <AudienceLow
                              highestSegments={highestSegments}
                              lowestSegments={lowestSegments}
                              participantsStatus={participants && participants.participant_status}
                            />

                    </CardContent>
                </Card>
            </Grid>

            </>
              )}

        </Grid>
        </Grid>  



       

      {/*</div>*/}
      { !fullLoading && runKnownOnboarding && sessionData && (sessionData['session']['session_status'].toLowerCase() === 'completed' &&
                sessionData['session']['session_type'] === 'ASYNC') && 
                <Joyride steps={knownTourSteps} 
                callback={handleJoyrideCallback} 
                debug={true} 
                run={forceOnboardingtoFalse}
                 disableScrolling={true} 
                 scrollToFirstStep={false} 
                 continuous={true} 
                 disableOverlay={true} 
                 showProgress={true} 
                 showSkipButton={true} 
                 styles={{
                        options: {
                          arrowColor: '#fdca42',
                          backgroundColor: '#fdca42',
                          overlayColor: 'rgba(0, 0, 0, 0.4)',
                          primaryColor: '#6667ab',
                          textColor: '#19191e',
                        }
                      }}
          /> }


        { !fullLoading && runLivelyOnboarding && sessionData && (sessionData['session']['session_status'].toLowerCase() === 'completed' &&
                sessionData['session']['session_type'] === 'MODERATED') && 
                <Joyride steps={livelyTourSteps} 
                callback={handleJoyrideCallback} 
                debug={true} 
                run={forceOnboardingtoFalse}
                 disableScrolling={true} 
                 scrollToFirstStep={false} 
                 continuous={true} 
                 disableOverlay={true} 
                 showProgress={true} 
                 showSkipButton={true} 
                 styles={{
                        options: {
                          arrowColor: '#fdca42',
                          backgroundColor: '#fdca42',
                          overlayColor: 'rgba(0, 0, 0, 0.4)',
                          primaryColor: '#6667ab',
                          textColor: '#19191e',
                        }
                      }}
          /> }





        
      <CustomSnackBar
        type={alertType}
        message={alertMsg}
        open={showAlert}
        onClose={() => setShowAlert(false)}
      />
      


    </div>
    </>
  )
}
